import { createIcon } from '@chakra-ui/react';

export const DashboardOutlineIcon = createIcon({
  displayName: 'DashboardOutlineIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M3.33301 7.16665H4.66634C5.99967 7.16665 6.66634 6.49998 6.66634 5.16665V3.83331C6.66634 2.49998 5.99967 1.83331 4.66634 1.83331H3.33301C1.99967 1.83331 1.33301 2.49998 1.33301 3.83331V5.16665C1.33301 6.49998 1.99967 7.16665 3.33301 7.16665Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.333 7.16665H12.6663C13.9997 7.16665 14.6663 6.49998 14.6663 5.16665V3.83331C14.6663 2.49998 13.9997 1.83331 12.6663 1.83331H11.333C9.99967 1.83331 9.33301 2.49998 9.33301 3.83331V5.16665C9.33301 6.49998 9.99967 7.16665 11.333 7.16665Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.333 15.1666H12.6663C13.9997 15.1666 14.6663 14.5 14.6663 13.1666V11.8333C14.6663 10.5 13.9997 9.83331 12.6663 9.83331H11.333C9.99967 9.83331 9.33301 10.5 9.33301 11.8333V13.1666C9.33301 14.5 9.99967 15.1666 11.333 15.1666Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33301 15.1666H4.66634C5.99967 15.1666 6.66634 14.5 6.66634 13.1666V11.8333C6.66634 10.5 5.99967 9.83331 4.66634 9.83331H3.33301C1.99967 9.83331 1.33301 10.5 1.33301 11.8333V13.1666C1.33301 14.5 1.99967 15.1666 3.33301 15.1666Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
